import React, { useState } from 'react';
import './WorkWithProgressChart.scss';
import { ProjectCounter } from '../ProjectCounter/ProjectCounter';
import { PortfolioSimpleIndicatorTable } from '../PortfolioSimpleIndicatorTable/PortfolioSimpleIndicatorTable';
import { getProjectsSimpleTableIndicator } from '../../../redux/actions/indicatorProjects';
import { useDispatch, useSelector } from 'react-redux';
import Indicator from '../../../models/Indicator';
import Project from '../../../models/Project';
import NumberFormat from 'react-number-format';
import { useTranslation } from 'react-i18next';
import { IndicatorKeyEnum } from '../../../models/IndicatorKeyEnum';
import { sortTablesByType } from '../../../services/sortsUtil';
import { handleLoading } from '../../utils';
import { setIndicatorResponse, setLoading } from '../../../redux/actions/dataTable';
import FilterIndicators from '../../../models/FilterIndicators';
import { AppMenuTabs } from '../../MenuTabs/userTabsInterface';
import { getNewFilteredIndicators } from '../../../api/indicatorApi';
import { translateMultipleText } from '../../../services/stringUtil';
import { emptyProjects } from '../../Portfolio/PortfolioUtil';
import { ProjectProductTypes } from '../../../models/ProjectProductTypes';
import { processIndicators } from '../../Portfolio/indicatorHelper';
import { arrayMove } from 'react-sortable-hoc';
import { addIndicators } from '../../../redux/actions/indicators';
import { setCurrentIndicator } from '../../../redux/actions/currentIndicator';
import { resetIndicatorDetailFilter } from '../../../redux/actions/indicatorDetailFilters';
import { updateCreatingOrEditing, updateMenuTabsFirstLoad } from '../../../redux/actions/menuTabs';
import Filter from '../../Portfolio/Filter/Filter';

interface ReceivedProps {
  currentIndicator: Indicator;
  itsDisbursed: boolean;
}

type Props = ReceivedProps;
export const WorkWithProgressChart = (props: Props) => {
  const { currentIndicator, itsDisbursed } = props;
  const dataIndicator = currentIndicator.data;
  const [loadingData, setLoadingData] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const indicatorProjects = useSelector<any, Project[]>(state => state.indicatorProjects);

  //Filter

  const filterIndicators = useSelector<any, FilterIndicators>(state => state.filterIndicators);
  const menuTabs = useSelector<any, AppMenuTabs>(state => state.menuTabs);
  const portfolioSelectedTab = menuTabs.portfolioSelectedTab;
  const creatingOrEditing = menuTabs.creatingOrEditing;
  const [isLoading, setIsLoading] = React.useState(false);
  const [totalProjects, setTotalProjects] = React.useState(false);
  const [flag, setFlag] = React.useState<boolean>(false);

  const handleCommonFilterChange = async () => {
    dispatch(setLoading(true));
    setIsLoading(true);

    try {
      const indicatorsToProcess = await getNewFilteredIndicators();
      dispatch(setIndicatorResponse(indicatorsToProcess));
      startProcessIndicators(
        indicatorsToProcess,
        translateMultipleText(` ${' '} ${portfolioSelectedTab.title}`, t),
        filterIndicators.common.projectTypeFilters,
      );
      setTotalProjects(emptyProjects(indicatorsToProcess.totalProjects));
    } catch (err) {
      console.error(err, 'Error fetching data from indicators');
    } finally {
      dispatch(setLoading(false));
      setIsLoading(false);
    }
  };

  const startProcessIndicators = (inds, titleFromTab, projectTypeFilter = [ProjectProductTypes.Loan]) => {
    const result = processIndicators(inds, {
      titleFromTab,
      projectTypeFilter,
    });
    const elementSummary: any = result.find(elem => elem.id === 15);
    const indexSummary: number = result.indexOf(elementSummary);
    const sendEndSummary = arrayMove(result, indexSummary, result.length);

    dispatch(addIndicators(sendEndSummary));
    dispatch(setCurrentIndicator(sendEndSummary?.find(data => data.id === 13)));
    setIsLoading(false);
  };

  // const tabId0OrCreatingEditing = (menuTabs, creatingOrEditing) =>
  //   menuTabs.portfolioSelectedTab.tabId === 0 || creatingOrEditing;

  React.useEffect(() => {
    handleLoading(() => getFilteredSimpleIndicators(dispatch, currentIndicator.id), setLoadingData);
  }, [currentIndicator.id, dispatch, filterIndicators.common]);

  React.useEffect(() => {
    if (
      filterIndicators.common.coReponsibleDivisions.length > 0 ||
      filterIndicators.common.countryId.length > 0 ||
      filterIndicators.common.divisionId.length > 0 ||
      filterIndicators.common.interestIssues.length > 0 ||
      filterIndicators.common.participantDivisions.length > 0 ||
      filterIndicators.common.regionId.length > 0 ||
      filterIndicators.common.sectors.length > 0 ||
      filterIndicators.common.teamLeaders.length > 0
    )
      handleCommonFilterChange();
    setFlag(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterIndicators.common]);

  React.useEffect(() => {
    dispatch(resetIndicatorDetailFilter());
    if (
      !menuTabs.firstLoad &&
      // tabId0OrCreatingEditing(menuTabs, creatingOrEditing) &&
      filterIndicators.common.coReponsibleDivisions.length === 0 &&
      filterIndicators.common.countryId.length === 0 &&
      filterIndicators.common.divisionId.length === 0 &&
      filterIndicators.common.interestIssues.length === 0 &&
      filterIndicators.common.participantDivisions.length === 0 &&
      filterIndicators.common.regionId.length === 0 &&
      filterIndicators.common.sectors.length === 0 &&
      filterIndicators.common.teamLeaders.length === 0 &&
      flag
    ) {
      handleCommonFilterChange();
      setFlag(false);
      if (creatingOrEditing) {
        dispatch(updateCreatingOrEditing(false));
      }
    }
    if (menuTabs.firstLoad) {
      dispatch(updateMenuTabsFirstLoad(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterIndicators.common]);

  return (
    <div
      className={
        indicatorProjects.length === 0
          ? 'work-with-progress-chart-container'
          : 'work-with-progress-chart-container adjust-height'
      }
    >
      <div className="title">{itsDisbursed ? t('disbursed') : t('pending')}</div>

      <div className="description">
        <NumberFormat
          value={itsDisbursed ? fixedMoneyValue(dataIndicator.disbursed) : fixedMoneyValue(dataIndicator.pending)}
          displayType={'text'}
          thousandSeparator={'.'}
          decimalSeparator={','}
          prefix={`${t('dolar_sign')} `}
        />
      </div>

      <div className="table-container">
        <PortfolioSimpleIndicatorTable
          projects={
            currentIndicator.indicatorKey === IndicatorKeyEnum.PORTFOLIO_OVERVIEW_INCLUDING_REGIONAL_PROJECTS
              ? sortTablesByType(indicatorProjects, true, 'code', 'string')
              : indicatorProjects
          }
          tableInfo={getDynamicTableFormat(itsDisbursed)}
          indicatorKey={currentIndicator.indicatorKey}
          loading={loadingData}
        />
        <ProjectCounter arrayToCount={indicatorProjects} countProjects={true} />
      </div>
    </div>
  );
};

export const getFilteredSimpleIndicators = (d, currentIndicatorId) => {
  return d(getProjectsSimpleTableIndicator(currentIndicatorId));
};

export const getDynamicTableFormat = isDisbursed => {
  switch (isDisbursed) {
    case true:
      return [
        {
          tableHeader: 'disbursed_to_date_01 dolar_sign_parentesis',
          rootProperty: 'field2',
          fieldType: 'money',
        },
      ];
    case false:
      return [
        {
          tableHeader: 'pending_disbursement dolar_sign_parentesis',
          rootProperty: 'field1',
          fieldType: 'money',
        },
      ];

    default:
      return [];
  }
};

const fixedMoneyValue = valueToFix => {
  return (valueToFix * 1000000).toFixed(0);
};
